import { useContext } from "react";
import { ReferencesContext } from "./ReferencesProvider.js";
const useReferencedEntity = (path, el) => {
  const ctx = useContext(ReferencesContext);
  return ctx(path, el);
};
export {
  useReferencedEntity
};
//# sourceMappingURL=useReferencedEntity.js.map
